import OregonCityPageTemplate from "@/pages/oregon-city/CityPageTemplate";
import { lebanonOrConfig } from "./data";

export default function LebanonOrPage() {
  return <OregonCityPageTemplate config={lebanonOrConfig} />;
}